import { Card } from "antd";
const Cards = ({ item }) => {
  return (
    <>
      <Card
        className="rounded-3xl flex flex-1 border border-[#D9D9D9] card-css h-[100px] sm:h-[100px] w-full"
        classNames={{ body: "w-full" }}
      >
        <div className="h-full flex flex-col justify-between">
          <div className="flex items-start gap-2 justify-between">
            <p className="text-start text-[clamp(12px,2.5vw,20px)] max-w-[120px]">{item?.title}</p>
            <div className="min-w-[45px] h-[45px] bg-[#A334341A] flex justify-center items-center rounded-xl">
              <img src={item?.image} alt="card-logo" />
            </div>
          </div>
          <p className="text-[clamp(18px,4.5vw,40px)] text-left">{item?.count}</p>
        </div>
      </Card>
    </>
  );
};

export default Cards;
